import {
  checkMessageEn,
  validateSpace,
  validateSpaceTextInput,
} from '@Utils/validation';
import {
  ICarbonFormValues,
  IGreenhouseGasOtherFormValues,
  IGreenhouseGoalFormValues,
  IGreenhouseGoalTermFormValues,
  INetZeroFormValues,
} from '../EsgGreenhouseFormProvider/types';

export const checkGhGoalTermComplete = (
  ghGoalTerm: IGreenhouseGoalTermFormValues
): boolean => {
  if (!ghGoalTerm) return false;

  const { greenhouseGoal } = ghGoalTerm;

  if (!greenhouseGoal || !checkExistGoals(greenhouseGoal)) return false;

  return checkGoalDetails(ghGoalTerm);
};

export const checkIntroRemarkValid = (
  ghGoalTerm: IGreenhouseGoalTermFormValues
): boolean => {
  const { greenhouseGoal, introduction, remark } = ghGoalTerm;

  if (!validateSpace(introduction?.descriptionTh)) return false;
  if (!validateSpaceTextInput(remark?.descriptionTh)) return false;
  if (!validateSpaceTextInput(greenhouseGoal?.remark?.descriptionTh)) {
    return false;
  }

  return true;
};

const checkExistGoals = (
  greenhouseGoal: IGreenhouseGoalFormValues
): boolean => {
  const { netZero, carbon, other } = greenhouseGoal.goals;

  return netZero || carbon || other;
};

const checkGoalDetails = (
  ghGoalTerm: IGreenhouseGoalTermFormValues
): boolean => {
  const { greenhouseGoal, netZero, carbon, other } = ghGoalTerm;

  const checkedDetailsComplete = [];

  if (greenhouseGoal?.goals.netZero) {
    const hasNetZeroDetail = netZero?.details
      ? netZero?.details.length > 0
      : false;
    checkedDetailsComplete.push(hasNetZeroDetail);
  }

  if (greenhouseGoal?.goals.carbon) {
    const hasCarbonDetail = carbon?.details
      ? carbon?.details.length > 0
      : false;
    checkedDetailsComplete.push(hasCarbonDetail);
  }

  if (greenhouseGoal?.goals.other) {
    const hasOtherDetail = other?.details ? other?.details.length > 0 : false;
    checkedDetailsComplete.push(hasOtherDetail);
  }

  return checkedDetailsComplete.every((checked) => checked);
};

export const checkGhGoalTermEnValid = (
  ghGoalTerm: IGreenhouseGoalTermFormValues
): boolean => {
  const { introduction, remark } = ghGoalTerm;

  const isIntroSpaceValid = validateSpace(introduction?.descriptionEn);
  const isRemarkSpaceValid = validateSpaceTextInput(remark?.descriptionEn);

  const isIntroductionEnValid =
    !introduction?.descriptionEn || checkMessageEn(introduction.descriptionEn);
  const isRemarkEnValid =
    !remark?.descriptionEn || checkMessageEn(remark.descriptionEn);

  return (
    isIntroductionEnValid &&
    isRemarkEnValid &&
    isIntroSpaceValid &&
    isRemarkSpaceValid
  );
};

export const checkGhGoalEnValid = (
  greenhouseGoal?: IGreenhouseGoalFormValues
): boolean => {
  const { remark } = greenhouseGoal || {};

  const isRemarkSpaceValid = validateSpaceTextInput(remark?.descriptionEn);
  const isRemarkEnValid =
    !remark?.descriptionEn || checkMessageEn(remark.descriptionEn);

  return isRemarkEnValid && isRemarkSpaceValid;
};

export const checkNetZeroThValid = (netZero?: INetZeroFormValues): boolean => {
  const { remark } = netZero || {};

  const isRemarkSpaceValid = validateSpaceTextInput(remark?.descriptionTh);

  return isRemarkSpaceValid;
};

export const checkNetZeroEnValid = (netZero?: INetZeroFormValues): boolean => {
  const { remark } = netZero || {};

  const isRemarkSpaceValid = validateSpaceTextInput(remark?.descriptionEn);
  const isRemarkEnValid =
    !remark?.descriptionEn || checkMessageEn(remark.descriptionEn);

  return isRemarkEnValid && isRemarkSpaceValid;
};

export const checkCarbonThValid = (carbon?: ICarbonFormValues): boolean => {
  const { remark } = carbon || {};

  const isRemarkSpaceValid = validateSpaceTextInput(remark?.descriptionTh);

  return isRemarkSpaceValid;
};

export const checkCarbonEnValid = (carbon?: ICarbonFormValues): boolean => {
  const { remark } = carbon || {};

  const isRemarkSpaceValid = validateSpaceTextInput(remark?.descriptionEn);
  const isRemarkEnValid =
    !remark?.descriptionEn || checkMessageEn(remark.descriptionEn);

  return isRemarkEnValid && isRemarkSpaceValid;
};

export const checkGhOtherThValid = (
  other?: IGreenhouseGasOtherFormValues
): boolean => {
  const { remark } = other || {};

  const isRemarkSpaceValid = validateSpaceTextInput(remark?.descriptionTh);

  return isRemarkSpaceValid;
};

export const checkGhOtherEnValid = (
  other?: IGreenhouseGasOtherFormValues
): boolean => {
  const { remark } = other || {};

  const isRemarkSpaceValid = validateSpaceTextInput(remark?.descriptionEn);
  const isRemarkEnValid =
    !remark?.descriptionEn || checkMessageEn(remark.descriptionEn);

  return isRemarkEnValid && isRemarkSpaceValid;
};
